/**
 * draggr.ts - Draggr (Drag & Drop) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const draggrModule = {
  id: 'ui-draggr',
  name: 'Drag & Drop',
  icon: '🖱️',
  category: 'modules',
  order: 13,
  
  packageInfo: {
    name: '@opcentral/draggr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Drag and drop system for OpCentral',
    status: 'in-progress',
    implementationProgress: 80,
    dependencies: {
      '@opcentral/core': '*',
      'react': '^18.0.0'
    },
    keywords: ['drag', 'drop', 'dnd', 'interaction', 'ui'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableDragDrop: {
      type: 'boolean',
      label: 'Enable Drag & Drop',
      description: 'Allow drag and drop interactions',
      defaultValue: true
    },
    
    showDropZones: {
      type: 'boolean',
      label: 'Highlight Drop Zones',
      description: 'Show visual indicators for drop zones',
      defaultValue: true,
      visible: (settings) => settings['ui-draggr.enableDragDrop']
    },
    
    dragThreshold: {
      type: 'number',
      label: 'Drag Threshold (px)',
      description: 'Pixels to move before drag starts',
      defaultValue: 5,
      min: 0,
      max: 20,
      visible: (settings) => settings['ui-draggr.enableDragDrop']
    }
  }
};

export default draggrModule;
